import styled, { keyframes } from "styled-components";

const modalFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`;

const backdropFadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledModalBackdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  animation: ${backdropFadeIn} 0.3s ease;
`;

export const StyledModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 65%;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  overflow: hidden;
  padding: 10px 20px 20px;
  box-sizing: border-box;

  @media (max-width: 1100px) {
    width: 70%;
  }

  @media (max-width: 900px) {
    width: 75%;
  }

  @media (max-width: 768px) {
    width: 98vw;
  }

  h2,
  p {
    margin: 0;
  }
`;

export const StyledModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;

  button {
    position: absolute;
    right: 20px;
    top: 10px;
  }
`;

export const StyledIframeContainer = styled.div`
  /* padding: 20px; */
  /* background: #000; */
  /* flex: 1; */
  border-radius: 8px;
`;

export const StyledIframe = styled.iframe`
  width: calc(100% - 1px);
  aspect-ratio: 16 / 9;
  border: 0px solid black;
  box-sizing: border-box;

  #player {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
  }
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
  p {
    /* color: #383838; */

    line-height: normal;
    font-size: 20px;
    /* font-weight: 500; */
  }
`;

export const StyledModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;

  span {
    border-radius: 4px;
    padding: 4px 8px;
    line-height: normal;
    font-size: 12px;
  }

  button,
  a {
    text-decoration: none;
    border: none;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    background: #eee;
    color: black;
    color: rgb(73, 73, 73);
    padding: 4px 12px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    font-weight: 400;
  }

  a {
    /* background: var(--opsColor);
    color: #fff; */
  }
`;
